import React from 'react'
import styled from 'styled-components'
import IconStarFilled from '../../vectors/IconStarFilled'

const Star = styled.div`
  margin-right: 10px;
  display: inline-block;

  svg {
    width: 24px;
    height: 24px;
  }
`

const IconStarMuted = styled(IconStarFilled)`
  path {
    fill: ${(props) => props.theme.colors.grey_light_op30};
  }
`

const StarRating = ({ value }) => {
  return (
    <div>
      {Array(5)
        .fill({})
        .map((star, index) => (
          <Star key={index}>
            {index < value ? <IconStarFilled /> : <IconStarMuted />}
          </Star>
        ))}
    </div>
  )
}

export default StarRating
